export const fontFamily = <const>{
  barlow: "Barlow",
  openSans: "Open Sans",
  roboto: "Roboto",
  chivo: "Chivo",
  playfairDisplay: "Playfair Display",
  inter: "Inter",
};
